var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF1F3",
    d: "M67.743 4.186s-13.698 20.3-35.614 8.191C10.214.269-11.702 33.032 7.17 52.975c18.873 19.943.405 30.901 13.226 43.124C34.967 109.99 47.653 81.82 59.22 88.23c25.528 14.148 44.44 8.547 40.179-7.834-7.48-28.756-17.046-30.627-9.74-45.584 7.304-14.958-8.818-46.057-21.916-30.627z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6BEC5",
    d: "M54.239 54.575v42.588L21.173 82.881l.158-42.434 32.908 14.128z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6CCD4",
    d: "M54.24 54.6v42.588L87.143 83.4V40.583L54.24 54.601z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6BEC5",
    d: "M54.239 54.575l33.066-13.85-32.806-14.541L21.173 40.38 54.24 54.575z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7DBE1",
    d: "M12.143 47.977L45.42 64.129c.09.043.19.056.288.036.097-.02.186-.07.251-.145l8.28-9.445L21.173 40.38l-9.104 6.827c-.062.046-.111.108-.143.18-.031.07-.044.148-.036.226.007.077.034.152.079.215.044.064.104.116.174.15zM87.305 40.726l9.183 8.302c.056.05.098.115.124.186.025.071.032.148.02.222-.012.075-.042.145-.088.205-.046.06-.106.108-.175.138L63.502 64.448c-.087.039-.185.049-.28.029-.093-.02-.178-.07-.242-.141l-8.741-9.76 33.066-13.85zM54.498 26.184l32.899 14.542 4.73-1.097c.094-.021.178-.072.24-.144.063-.072.102-.162.11-.257.009-.095-.013-.19-.062-.272-.048-.083-.122-.147-.21-.185l-30.04-13.017c-.065-.028-.136-.04-.208-.036l-7.459.466z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7DBE1",
    d: "M54.498 26.184L21.785 40.447l-4.136-.695c-.095-.018-.183-.066-.25-.137-.065-.072-.107-.162-.117-.26-.011-.096.01-.194.059-.278.049-.084.124-.15.213-.188l30.783-13.266c.068-.029.142-.04.216-.035l5.946.596z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyView);
export default __webpack_public_path__ + "static/media/EmptyView.53f86877.svg";
export { ForwardRef as ReactComponent };